import { useMemo, FC } from "react";
import { Bot, Workflow } from "lucide-react";

import { ShoprenterIcon } from "@/components/icons/ShoprenterIcon";
import { AppImage } from "@/components/app/AppImage";
import { cn } from "@/lib/utils";
import { RiTimerFlashFill } from "@remixicon/react";
import { ShopifyIcon } from "@/components/icons/ShopifyIcon";

type ActivityIconType = FC<{ className?: string }>;

const activityGroupLogos: Record<string, ActivityIconType> = {
  shoprenter: ShoprenterIcon,
  shopify: ShopifyIcon,
  internal: ({ className }) => <AppImage type="icon" className={className} />,
  chatbot: Bot,
  default: Workflow,
};

const activityLogos: Record<string, ActivityIconType> = {
  delay: ({ className }) => <RiTimerFlashFill className={cn("h-6 w-6 text-red-700", className)} />,
};

export function ActivityIcon({
  group, name, className
}: { group: string, name?: string, className?: string }) {
  const ActivityIcon = useMemo(() => {
    const activityLogo = activityLogos[name ?? ''];

    if (activityLogo) {
      return activityLogo;
    }

    return activityGroupLogos[group] || activityGroupLogos.default;
  }, [group, name]);

  return <ActivityIcon className={cn("h-6 w-6", className)} />;
}
